import type { Direction } from "../../../engine/direction";
import { BurstParticle } from "./burstParticle";

export class MetalDebrisParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction) {
		super(
			originX,
			originY,
			{
				ttl: [300, 600],
				size: [0.40, 0.25],
				color: { r: 90, g: 95, b: 100 },
				speed: [1.5, 3.5],
				gravity: 5.5,
			},
			direction,
		);
	}
}
